<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatórios</app-titulo>
      <div class="header-buttons">
        <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
        <app-botao type="secundario" class="button" text="Exportar PDF" icon="assets/download.svg"
          (click)="exportarPDF()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Histórico por Veículo</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input
              label="Placa *"
              mask="AAA-0A00"
              placeholder="Digite a placa"
              name="TX_PLCA"
              formControlName="TX_PLCA"
              width="100%"
            ></app-input>
            <app-input
              type="datetime-local"
              label="Data Início"
              placeholder="Digite aqui"
              name="DT_INIC"
              formControlName="DT_INIC"
              width="100%"
            ></app-input>
            <app-input
              type="datetime-local"
              label="Data Final"
              placeholder="Digite aqui"
              name="DT_FIM"
              formControlName="DT_FIM"
              width="100%"
            ></app-input>
          </form>
        </div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <div class="table-scroll" *ngIf="!isLoading">
        <app-tabela
          [data]="tableData"
          [columns]="tableColumns"
        ></app-tabela>
      </div>
    </div>
  </div>

  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Placa *"
        mask="AAA-0A00"
        placeholder="Digite a placa"
        name="TX_PLCA"
        formControlName="TX_PLCA"
        width="100%"
      ></app-input>
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_INIC"
        formControlName="DT_INIC"
        width="100%"
      ></app-input>
      <app-input
        type="datetime-local"
        label="Data Final"
        placeholder="Digite aqui"
        name="DT_FIM"
        formControlName="DT_FIM"
        width="100%"
      ></app-input>
    </form>

    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true"
    ></app-card>
  </div>

  <app-subtitulo *ngIf="!tableData.length && !isLoading">
    {{ form.controls.TX_PLCA.value ? 'Nenhum registro encontrado.' : 'Digite uma placa para buscar o histórico.' }}
  </app-subtitulo>

  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"
    ></app-paginacao>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
